import { useTranslation } from "react-i18next";
import { useBasicComponents, requiredRule } from "./useBasicComponent";

export const useGiteaConfig = (action = "create", defaultValues = {}) => {
  const { t } = useTranslation();
  const { replicas, core, memory, dataDisk, nodegroup } = useBasicComponents(
    action,
    defaultValues,
  );

  const giteaColumns = () => {
    const group = "gitea";
    return [
      // Editable: GiteaHelm.overrideValues() reads this to build the pod's nodeSelector at
      // deploy time, and GiteaHelm.update_more() patches the live Deployment's nodeSelector
      // on change (Deployment rolls its own pod, no separate restart step needed).
      nodegroup({ group }),
      // Editable, but bounded at 1. The chart mounts one fixed-name ReadWriteOnce volume
      // (gitea-shared-storage) and switches the claim to ReadWriteMany above one replica,
      // which the gp3 storage class cannot provide -- so 2+ does not merely risk trouble,
      // it leaves the PVC permanently Pending. 0 is allowed and means "defined but not
      // running", the same convention druid-all uses in the shipped profiles.
      replicas({
        group,
        formItemProps: {
          rules: [
            ...requiredRule(t),
            {
              validator(_, value) {
                if (value === undefined || value === null || value === "") {
                  return Promise.resolve();
                }
                const n = Number(value);
                if (Number.isInteger(n) && n >= 0 && n <= 1) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t(
                      "config.instance.error.giteaReplicas",
                      "Gitea supports 0 or 1 replica: its volume is ReadWriteOnce and gp3 cannot provide the ReadWriteMany claim the chart switches to above one replica.",
                    ),
                  ),
                );
              },
            },
          ],
        },
      }),
      core({ group }),
      memory({ group }),
      dataDisk({ group }),
    ];
  };

  const giteaSchema = [
    {
      title: t("config.instance.form.gitea", "Gitea"),
      valueType: "group",
      columns: giteaColumns(),
    },
  ];

  return giteaSchema;
};
